import useState from "./useState";


interface IStateValues {
    open: boolean;
    value: string;
}

const useSearch = () => {
    const state = useState<IStateValues>({
        open: false,
        value: ''
    });

    return {
        open: state.values.open,
        handleOpen: () => state.update('open', true),
        handleClose: () => state.update('open', false),
        value: state.values.value,
        handleChangeValue: (text: string) => state.update('value', text),
        reset: () => {
            state.reset();
        }
    };
}

export default useSearch;